// eslint-disable-next-line import/no-unresolved
import md5 from 'md5';

export const getGravatarUrlFromEmail = email =>
  `https://www.gravatar.com/avatar/${md5((email || '').trim().toLowerCase())}`;
